<template>
  <div class="cf-card cf-card--background-brand-secondary cf-flex cf-flex--row cf-flex--align-start cf-flex--justify-space-between cf-flex--gap-16 cf-mobile-column">
    <div class="cf-flex cf-flex--column cf-flex--align-start cf-flex--gap-8">
      <h3 class="cf-title cf-title--3 cf-title--white">
        {{ content.Loyalty.metadata.referFriendsTitle }}
      </h3>

      <p class="cf-subtitle cf-subtitle--2 cf-subtitle--white">
        {{ content.Loyalty.metadata.referFriendsSubTitle }}
      </p>
    </div>

    <button
      class="cf-button cf-button--secondary cf-button--md cf-button--mobile-fill cf-align-self-center"
      type="button"
      @click="$openModal('referFriends')"
    >
      Share
    </button>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'ReferAFriendCta',

    computed: {
      ...mapGetters('content', ['content'])
    }
  };
</script>
